import React, { useState } from 'react';
import apinode from '../../services/apinode';
import Navbar from '../../components/navbar/navbar.jsx'

export default function ImportarNFeModerna() {
    const [produtos, setProdutos] = useState([]);
    const [fornecedor, setFornecedor] = useState(null);
    const [dadosNota, setDadosNota] = useState(null);

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const text = await file.text();
        const parser = new DOMParser();
        const xml = parser.parseFromString(text, "text/xml");

        const ide = xml.getElementsByTagName("ide")[0];
        const infNFe = xml.getElementsByTagName("infNFe")[0];
        const emit = xml.getElementsByTagName("emit")[0]; // <- agora vem antes de usar
        const enderEmit = emit?.getElementsByTagName("enderEmit")[0];

        const getTag = (tag, parent = xml) =>
            parent?.getElementsByTagName(tag)?.[0]?.textContent || "";

        const dadosNotaExtraidos = {
            id: "",
            numNFe: getTag("nNF", ide),
            serieNFe: getTag("serie", ide),
            dataEmissao: getTag("dhEmi", ide) || getTag("dEmi", ide),
            dataEntrada: getTag("dhEnt", ide) || new Date().toISOString(),
            total: parseFloat(getTag("vNF", xml)) || 0,
            acrescimo: parseFloat(getTag("vOutro", xml)) || 0,
            desconto: parseFloat(getTag("vDesc", xml)) || 0,
            frete: parseFloat(getTag("vFrete", xml)) || 0,
            icmsFrete: 0,
            tipoEntrada: "ENTRADA",
            vlrBaseICMSST: parseFloat(getTag("vBCST", xml)) || 0,
            vlrICMSST: parseFloat(getTag("vST", xml)) || 0,
            totalProdutos: parseFloat(getTag("vProd", xml)) || 0,
            codificacaoFiscal: getTag("CFOP", xml),
            emissorCodigoEstado: getTag("cUF", ide),
            chaveNFe: infNFe?.getAttribute("Id")?.replace("NFe", "") || "Não encontrada",
            bcICMS: parseFloat(getTag("vBC", xml)) || 0,
            valorICMS: parseFloat(getTag("vICMS", xml)) || 0,
            valorPIS: parseFloat(getTag("vPIS", xml)) || 0,
            valorCOFINS: parseFloat(getTag("vCOFINS", xml)) || 0,
            valorIPI: parseFloat(getTag("vIPI", xml)) || 0,
            valorSeguro: parseFloat(getTag("vSeg", xml)) || 0,
            freteIncluso: false,
            valorICMSSubIncluso: false,
            custoSemDesconto: 0,
            fornecRazao: getTag("xNome", emit),
            fornecEndereco: `${getTag("xLgr", enderEmit)}, ${getTag("nro", enderEmit)}`,
            fornecBairro: getTag("xBairro", enderEmit),
            fornecCidade: getTag("xMun", enderEmit),
            fornecCEP: getTag("CEP", enderEmit),
            fornecUF: getTag("UF", enderEmit),
            fornecCNPJ: getTag("CNPJ", emit),
            fornecINSC: getTag("IE", emit),
            fornecTel: getTag("fone", enderEmit),
            fornecNumero: getTag("nro", enderEmit),
            fornecIBGE: getTag("cMun", enderEmit),
            fornecTipo: "",
            transpNome: getTag("xNome", xml.getElementsByTagName("transporta")[0]),
            transpEndereco: getTag("xEnder", xml.getElementsByTagName("transporta")[0]),
            transpCidade: getTag("xMun", xml.getElementsByTagName("transporta")[0]),
            transpUF: getTag("UF", xml.getElementsByTagName("transporta")[0]),
            transpCNPJ: getTag("CNPJ", xml.getElementsByTagName("transporta")[0]),
            transpINSC: getTag("IE", xml.getElementsByTagName("transporta")[0]),
            transpPLACA: getTag("placa", xml.getElementsByTagName("veicTransp")[0]),
            transpUFPLACA: getTag("UF", xml.getElementsByTagName("veicTransp")[0]),
            transpTIPO: "",
            status: "ATIVA",
            entradaTipo: "MANUAL",
            tipo_entrada: "XML",
            forn_cod: "",
            pesoTotal: parseFloat(getTag("pesoB", xml)) || 0,
            outrasDespesas: parseFloat(getTag("vOutro", xml)) || 0,
            contasLanc: false,
            geradaConf: false,
            calcImp: false,
            addCont: false,
            conta: localStorage.idconta
        };

        setDadosNota(dadosNotaExtraidos);

        const fornecedorExtraido = {
            cnpj: getTag("CNPJ", emit),
            nome: getTag("xNome", emit),
            fantasia: getTag("xFant", emit),
            ie: getTag("IE", emit),
            endereco: `${getTag("xLgr", enderEmit)}, ${getTag("nro", enderEmit)} - ${getTag("xBairro", enderEmit)}, ${getTag("xMun", enderEmit)} - ${getTag("UF", enderEmit)}`
        };

        setFornecedor(fornecedorExtraido);

        const produtosXML = Array.from(xml.getElementsByTagName("det"));

        const produtosExtraidos = await Promise.all(produtosXML.map(async (item) => {
            const prod = item.getElementsByTagName("prod")[0];
            const ean = prod.getElementsByTagName("cEAN")[0]?.textContent || "Sem EAN";

            let produtoCorrespondente = null;

            if (ean && ean !== "Sem EAN") {
                try {
                    const response = await apinode.get(`/buscar-por-ean/${localStorage.idconta}/${ean}`);
                    produtoCorrespondente = response.data;
                } catch (error) {
                    console.warn(`Produto com EAN ${ean} não encontrado.`);
                }
            }

            return {
                codigo: prod.getElementsByTagName("cProd")[0]?.textContent,
                ean,
                descricao: prod.getElementsByTagName("xProd")[0]?.textContent,
                quantidade: prod.getElementsByTagName("qCom")[0]?.textContent,
                valorUnitario: prod.getElementsByTagName("vUnCom")[0]?.textContent,
                valorTotal: prod.getElementsByTagName("vProd")[0]?.textContent,
                produtoCorrespondente,
            };
        }));

        setProdutos(produtosExtraidos);
    };

    const handleGravar = async () => {
        if (!dadosNota || !fornecedor || produtos.length === 0) {
            alert("Dados incompletos. Verifique o XML.");
            return;
        }
    
        try {
            // Montar a nota para envio - adicionando ID único (exemplo)
            const notaParaEnvio = {
                ...dadosNota,
                id: Date.now().toString(), // exemplo simples de id
            };
    
            // Montar fornecedor para envio (deixando igual)
            const fornecedorParaEnvio = {
                ...fornecedor,
            };
    
            // Mapear produtos para o formato esperado pelo backend
            const produtosParaEnvio = produtos.map((p, index) => ({
                ID: `${Date.now()}_${index}`,  // ID único do produto
                IDNFE: notaParaEnvio.id,
                CODIGOPRODUTO: p.codigo || "",
                EAN: p.ean || "",
                PRODUTO: p.descricao || "",
                NCM: "", // você pode extrair do XML se quiser
                MEDIDA: "", // 
                QUANTIDADE: parseFloat(p.quantidade) || 0,
                VALOR: parseFloat(p.valorUnitario) || 0,
                VALORTOTAL: parseFloat(p.valorTotal) || 0,
                ORIG: "", CST: "", CSOSN: "", CRT: "", // preencher se necessário
                BCICMS: 0, PORCICMS: 0, VALORICMS: 0,
                BCICMSST: 0, PORCICMSST: 0, VALORICMSST: 0,
                BCIPI: 0, PORCIPI: 0, VALORIPI: 0,
                DESCONTO: 0, IPICST: 0, PREDBC: 0, PREDBCST: 0,
                PISCST: 0, PISBC: 0, PISALIQ: 0, PISVALOR: 0,
                COFINSCST: 0, COFINSBC: 0, COFINSALIQ: 0, COFINSVALOR: 0,
                CFOP: dadosNota.codificacaoFiscal || "",
                SKU_MATCH: p.produtoCorrespondente?.[0]?.sku || "",
                DESC_MATCH: p.produtoCorrespondente?.[0]?.descricao || "",
                MATCH: !!p.produtoCorrespondente?.length,
                CODPRODUTO_MATCH: p.produtoCorrespondente?.[0]?.codigo || "",
                CUSTO: 0 // preencher se desejar
            }));
    
            const payload = {
                nota: notaParaEnvio,
                fornecedor: fornecedorParaEnvio,
                produtos: produtosParaEnvio
            };
    
            const response = await apinode.post(`/importar-nfe/${localStorage.idconta}`, payload);
    
            if (response.status === 200 || response.status === 201) {
                alert("Nota Fiscal importada com sucesso!");
                handleLimpar();
            } else {
                alert("Erro ao importar nota fiscal.");
            }
        } catch (error) {
            console.error(error);
            alert("Erro ao enviar dados para o servidor.");
        }
    };
    
    
    const handleLimpar = () => {
        setFornecedor(null);
        setProdutos([]);
        setDadosNota(null);
    };
    const handleVoltar = () => window.history.back();

    const totalGeral = produtos.reduce((acc, p) => acc + parseFloat(p.valorTotal || 0), 0);

    return (
        <>
        <Navbar />

        <div className=" mt-page container py-2">
            <div className="card shadow-sm p-3 rounded-3 small">
                <h6 className="mb-3 text-center text-primary fw-bold">
                    <i className="bi bi-file-earmark-arrow-up-fill me-1"></i>Importar NF-e
                </h6>

                <div className="d-flex justify-content-center mb-3">
                    <div style={{ maxWidth: "400px", width: "100%" }}>
                        <label htmlFor="xmlFile" className="form-label fw-semibold small">Selecionar XML:</label>
                        <input
                            type="file"
                            accept=".xml"
                            className="form-control form-control-sm"
                            onChange={handleFileChange}
                        />
                    </div>
                </div>

                {dadosNota && (
                    <div className="mb-3 border-top pt-2">
                        <div className="fw-bold text-secondary mb-1">Nota Fiscal:</div>
                        <div className="row small">
                            <div className="col"><strong>Número:</strong> {dadosNota.numNFe}</div>
                            <div className="col"><strong>Série:</strong> {dadosNota.serieNFe}</div>
                            <div className="col"><strong>Data:</strong> {new Date(dadosNota.dataEmissao).toLocaleString("pt-BR")}</div>
                            <div className="col"><strong>Chave:</strong> {dadosNota.chaveNFe}</div>
                        </div>
                    </div>
                )}

                {fornecedor && (
                    <div className="mb-3 border-top pt-2">
                        <div className="fw-bold text-secondary mb-1">Fornecedor:</div>
                        <div className="row small">
                            <div className="col-md-4"><strong>CNPJ:</strong> {fornecedor.cnpj}</div>
                            <div className="col-md-4"><strong>Nome:</strong> {fornecedor.nome}</div>
                            <div className="col-md-4"><strong>Fantasia:</strong> {fornecedor.fantasia}</div>
                            <div className="col-md-4"><strong>IE:</strong> {fornecedor.ie}</div>
                            <div className="col-md-8"><strong>Endereço:</strong> {fornecedor.endereco}</div>
                        </div>
                    </div>
                )}

                {produtos.length > 0 && (
                    <div className="border-top pt-2">
                        <div className="fw-bold text-secondary mb-1">Produtos:</div>
                        <div className="table-responsive">
                            <table className="table table-bordered table-sm align-middle text-nowrap" style={{ fontSize: "0.9rem", tableLayout: "fixed" }}>
                                <thead className="table-light text-center" style={{ fontSize: "0.65rem" }}>
                                    <tr>
                                        <th style={{ width: "8%" }}>Cód.</th>
                                        <th style={{ width: "12%" }}>EAN</th>
                                        <th style={{ width: "40%" }}>Descrição</th>
                                        <th style={{ width: "10%" }}>Qtd</th>
                                        <th style={{ width: "12%" }} className="d-none d-md-table-cell">Unit.</th>
                                        <th style={{ width: "12%" }}>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {produtos.map((p, i) => (
                                        <tr key={i}>
                                            <td>{p.codigo}</td>
                                            <td>{p.ean}</td>
                                            <td style={{ whiteSpace: "normal", maxWidth: "220px" }}>
                                                {p.descricao}
                                                {p.produtoCorrespondente && p.produtoCorrespondente.length > 0 ? (
                                                    <div className="text-success small" title={`SKU: ${p.produtoCorrespondente[0]?.sku} - ${p.produtoCorrespondente[0]?.descricao}`}>
                                                        ✔ SKU: {p.produtoCorrespondente[0]?.sku} - {p.produtoCorrespondente[0]?.descricao}
                                                    </div>
                                                ) : (
                                                    <div className="text-danger small">❌</div>
                                                )}
                                            </td>
                                            <td style={{ textAlign: "center" }}>{p.quantidade}</td>
                                            <td style={{ textAlign: "right" }} className="d-none d-md-table-cell">
                                                R$ {parseFloat(p.valorUnitario).toFixed(2)}
                                            </td>
                                            <td style={{ textAlign: "right" }}>
                                                R$ {parseFloat(p.valorTotal).toFixed(2)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="d-flex justify-content-end mt-2">
                            <div className="fw-semibold text-end" style={{ fontSize: "0.75rem" }}>
                                Total Geral:&nbsp;
                                <span className="text-success">R$ {totalGeral.toFixed(2)}</span>
                            </div>
                        </div>

                        <div className="d-flex justify-content-end gap-2 mt-3">
                            <button className="btn btn-success btn-sm" onClick={handleGravar} title="Gravar">
                                <i className="bi bi-save"></i>
                            </button>
                            <button className="btn btn-warning btn-sm" onClick={handleLimpar} title="Limpar">
                                <i className="bi bi-trash3"></i>
                            </button>
                            <button className="btn btn-secondary btn-sm" onClick={handleVoltar} title="Voltar">
                                <i className="bi bi-arrow-left"></i>
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
        </>
    );
}
